<template>
  <div class="navbar-wrapper">
    <b-navbar
      toggleable="lg"
      type="light"
      :sticky="true"
      class="navbar-static-top container"
    >
      <b-navbar-brand class="logo-wrapper" href="/">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="40"
          viewBox="0 0 276.85 64"
        >
          <g
            id="Group_4532"
            data-name="Group 4532"
            transform="translate(-3027 -1852)"
          >
            <g id="Group_4531" data-name="Group 4531">
              <path
                id="Path_23854"
                data-name="Path 23854"
                d="M6,0H58a6,6,0,0,1,6,6V58a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z"
                transform="translate(3027 1852)"
                fill="#00a86b"
              />
              <path
                id="Path_23832"
                data-name="Path 23832"
                d="M52.326,73.669V57.445a.721.721,0,0,1,.721-.721H69.27a.721.721,0,0,1,.721.721V72.383a.724.724,0,0,1-.081.331L62.195,87.622a.721.721,0,0,1-.64.389H55.513a.721.721,0,0,1-.68-.962l4.15-11.7a.721.721,0,0,0-.679-.962H53.047a.721.721,0,0,1-.721-.721m24.335,0V57.445a.721.721,0,0,1,.721-.721H93.605a.721.721,0,0,1,.721.721V72.383a.719.719,0,0,1-.081.331L86.527,87.622a.72.72,0,0,1-.64.389H79.848a.721.721,0,0,1-.679-.962l4.15-11.7a.72.72,0,0,0-.679-.962H77.382a.721.721,0,0,1-.721-.721"
                transform="translate(2985.674 1811.276)"
                fill="#fff"
              />
            </g>
            <path
              id="Path_23853"
              data-name="Path 23853"
              d="M-78,0h8.55V-35.1H-78v13.75H-91.3V-35.1h-8.55V0h8.55V-14.45H-78Zm14.55-14.15c0,9.7,6.35,14.5,14.5,14.5,8.1,0,14.9-4.8,14.9-14.5V-35.1H-42.6v21c0,4.15-2.15,6.55-6.2,6.55s-6.1-2.4-6.1-6.55v-21h-8.55ZM-4.1,0H4.95L-7.75-35.1h-9.9L-30.35,0h8.95l2.1-6.2H-6.2ZM-8.4-12.8h-8.65l4.3-12.85ZM27.35-23.7c0,2.75-1.5,4.4-4.7,4.4h-5.3V-28h5.3C25.85-28,27.35-26.3,27.35-23.7ZM8.8-35.1V0h8.55V-13.25H19.4L26.7,0h9.65l-8.1-13.9a10.217,10.217,0,0,0,7.8-10.15c0-6.1-4.3-11.05-12.9-11.05Zm54.1,0H41.4V0H62.9V-6.85H49.95v-7.7H61.4v-6.6H49.95v-7.1H62.9Zm28.4,0v21.75L77-35.1H68.45V0H77V-21.65L91.3,0h8.55V-35.1Z"
              transform="translate(3204 1901)"
              fill="#00a86b"
            />
          </g>
        </svg>
      </b-navbar-brand>
      <span
        @click="toggleTheme"
        class="theme-switch-btn"
        title="switch theme between dark and light"
      >
        <i class="el-icon-moon" v-if="theme === 'dark'"></i>
        <i class="el-icon-sunny" v-else></i>
      </span>
      <el-menu
        :default-active="currentCategoryId"
        @select="handleMenuSelect"
        mode="horizontal"
        style="margin:auto"
      >
        <el-submenu index="1" class="mobileView">
          <template slot="title"
            >{{ currentCategory() ? currentCategory().name : "分类" }}
          </template>
          <ChooseCityComponent></ChooseCityComponent>
          <span v-for="(category, index) in menuCategories" :key="category.id">
            <el-submenu
              v-if="category.subcategories.length > 0"
              :index="index.toString()"
            >
              <template slot="title">
                <el-menu-item :index="category.id">
                  {{ category.name }}
                </el-menu-item>
              </template>
              <el-menu-item
                v-for="subcategory in category.subcategories"
                :key="subcategory.id"
                :index="subcategory.id"
              >
                {{ subcategory.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="category.id">
              {{ category.name }}
            </el-menu-item>
          </span>
        </el-submenu>
      </el-menu>
      <SearchComponent
        class="desktopView"
        id="desktop-search"
      ></SearchComponent>
      <div class="userHeader text-right">
        <Notification v-if="isLoggedIn">
          <b-navbar-nav class="ml-auto">
            <el-button
              class="desktopView btn-primary create-post-btn"
              v-b-modal.postTopic
            >
              <i class="el-icon-edit"></i>
              新建
            </el-button>

            <el-dropdown
              class="margin-auto"
              @command="handleMenuCommand"
              trigger="click"
            >
              <span class="el-dropdown-link">
                <el-avatar
                  fit="cover"
                  v-if="user.avatar"
                  :src="user.avatar"
                  class="alignAvatar"
                >
                </el-avatar>
                <el-avatar v-else icon="el-icon-user-solid"> </el-avatar>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="'/user/me'">
                  <i class="el-icon-user"></i>
                  我的话题
                </el-dropdown-item>
                <el-dropdown-item command="/user/settings">
                  <i class="el-icon-collection-tag"></i>
                  订阅标签
                </el-dropdown-item>
                <el-dropdown-item command="/notifications/replies">
                  <el-badge
                    :value="
                      user.notification_count > 0 ? user.notification_count : ''
                    "
                    :max="100"
                  >
                    <i class="el-icon-message"></i>
                    我的通知
                  </el-badge>
                </el-dropdown-item>
                <el-dropdown-item :command="'/messages?id=' + user.id">
                  <el-badge
                    :value="user.message_count > 0 ? user.message_count : ''"
                    :max="100"
                  >
                    <i class="el-icon-chat-dot-round"></i>
                    私信消息
                  </el-badge>
                </el-dropdown-item>
                <el-dropdown-item command="/user/edit">
                  <i class="el-icon-edit"></i>
                  个人资料
                </el-dropdown-item>
                <el-dropdown-item command="/user/profile">
                  <i class="el-icon-link"></i>
                  个人主页
                </el-dropdown-item>
                <el-dropdown-item command="/user/subscription">
                  <i class="el-icon-bank-card"></i>
                  会员信息
                </el-dropdown-item>
                <el-dropdown-item command="logout" divided
                  >退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </b-navbar-nav>
        </Notification>
        <div v-else>
          <!-- 登录前 -->
          <el-button
            @click="setShowLoginModalSwitch(true)"
            class="mobileView btn-primary"
            icon="el-icon-user"
            circle
          >
          </el-button>
          <el-button
            class="desktopView btn-primary"
            @click="setShowLoginModalSwitch(true)"
            >登录/注册
          </el-button>
        </div>
      </div>
      <b-modal
        ref="loginModal"
        id="loginModal"
        centered
        scrollable
        title="登录/注册"
        @hide="hideLoginModal"
        hide-footer
      >
        <LoginAndRegister :action="this.action"></LoginAndRegister>
      </b-modal>
    </b-navbar>
    <el-button
        v-if="isLoggedIn"
        v-b-modal.postTopic
        class="postTopicButton mobileView btn-primary"
        icon="el-icon-plus"
        circle
    >
    </el-button>
    <SearchComponent
        class="searchInput mobileView"
        id="searchInput"
    ></SearchComponent>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import LoginAndRegister from "./LoginAndRegister.vue";
import Notification from "./Notification.vue";
import ChooseCityComponent from "./ChooseCityComponent";
import SearchComponent from "./SearchComponent";

export default {
  data: function() {
    return {
      action: "login",
      mainCategoryNames: ["corona", "jobs", "housing", "cars", "market"],
      themeIcon: "el-icon-moon"
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "menuCategories", "currentCategory"]),
    ...mapState([
      "topicsUrl",
      "tagsUrl",
      "currentCategoryId",
      "user",
      "token",
      "theme",
      "showLoginModalSwitch"
    ]),

    mainCategories: function() {
      return this.menuCategories.slice(0, 4);
    },
    otherCategories: function() {
      return this.menuCategories.slice(4);
    }
  },
  mounted() {
    let storedTheme = localStorage.getItem("theme"); //gets stored theme value if any
    if (storedTheme === "dark" || storedTheme === "light") {
      this.setTheme(storedTheme);
      this.switchTheme();
      return;
    }
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      this.setTheme("dark");
    } else {
      this.setTheme("light");
    }
    this.switchTheme();
  },
  methods: {
    ...mapMutations(["loginWithToken", "setShowLoginModalSwitch", "setTheme"]),
    handleMenuSelect: function(key) {
      this.$router.push("/categories/" + key);
    },
    handleMenuCommand: function(command) {
      if (command === "logout") {
        this.$store.dispatch("logout").then(() => {
          window.location.href = this.$router.currentRoute.fullPath;
        });
      } else {
        this.$router.push(command);
      }
    },
    showLoginModal(action) {
      this.action = action;
      this.$refs["loginModal"].show();
    },
    hideLoginModal: function() {
      this.setShowLoginModalSwitch(false);
    },
    toggleTheme() {
      this.setTheme(this.theme === "dark" ? "light" : "dark");
      this.switchTheme();
    },
    switchTheme() {
      document.documentElement.setAttribute("data-theme", this.theme); // sets the data-theme attribute
      localStorage.setItem("theme", this.theme); // stores theme value on local storage
    }
  },
  watch: {
    isLoggedIn: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.$refs["loginModal"].hide();
      }
    },
    showLoginModalSwitch: function(newVal) {
      if (newVal) {
        this.showLoginModal("login");
      } else {
        this.$refs["loginModal"].hide();
      }
    }
  },
  components: {
    LoginAndRegister,
    ChooseCityComponent,
    Notification,
    SearchComponent
  },
  created: function() {
    // handle global axios error
    this.$http.interceptors.response.use(undefined, error => {
      if (
        error.response.status === 401 &&
        error.config &&
        !error.config._retry
      ) {
        // if the error is 401 and hasn't already been retried
        // if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
        error.config._retry = true; // now it can be retried

        this.$http({
          url: "/authorizations/current",
          method: "PUT"
        })
          .then(resp => {
            // refresh token succeeded
            // save token
            const token = resp.data.access_token;
            this.loginWithToken(token);
          })
          .catch(() => {
            this.$store.dispatch("logout");
          });
      } else if (
        error.response.status === 500 ||
        error.response.status === 404
      ) {
        //skip
      } else {
        var errorMessage = error.response.data.errors
          ? JSON.stringify(error.response.data.errors)
          : error.message
          ? error.message
          : "出错了";
        this.$message({
          showClose: true,
          message: errorMessage,
          type: "error"
        });
      }

      return Promise.reject(error);
    });
  }
};
</script>
<style>
.nav-link.active {
  color: white !important;
}
</style>
